import { computed } from 'vue'

import type { RouteStoreType } from '@/store/route/route.store'

export function selectGetCurrentRoute(state: RouteStoreType) {
  return computed(() => state.currentRoute)
}
